export const API_CONFIG = {
  API_BASE: `${process.env.API_BASE}api/`,
  API_VERSIONS: {
    V1: 'v1/',
  },
};

export const { GOOGLE_CLIENT_ID } = process.env;

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_VERBOSE = 'MMM D, YYYY';

export const DATE_FORMAT_SLASHES = 'MM/DD/YY';
export const FULLDATE_FORMAT_SLASHES = 'MM/DD/YYYY';

export const DATE_FORMAT_SHORT = 'MMM DD';
export const DATE_FORMAT_NO_TIME_ZONE = 'YYYY-MM-DD[T]HH:mm:ss';
export const DATE_FORMAT_CSV = 'YYYYMMDD-HHmmss';
export const EMAIL_DATE_FORMAT = 'ddd, MMM D, h:mm A';
export const LAST_UPDATED = 'MM/DD/YY, h:mm a';

export const TIME_FORMAT = 'h:mm a';
// used to control order of weekdays
export const WEEK_DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

export const DEFAULT_EMAILS_PER_DAY = 50;

export const MIN_DELAY_BETWEEN_EMAILS = 5;
export const DEFAULT_DELAY_BETWEEN_EMAILS = 300;

export const OTHER_CONFIG = {};

export const PAGE_SIZE = 25;
export const PAGE_SIZE_LARGE = 50;

export const REDIRECT_PARAM = 'next';

export const EMAIL_BACKEND_CONFIG = {
  sendgrid: {
    hasTrackingUI: false,
    espTxtValue: 'v=spf1 include:sendgrid.net ~all',
  },
  mailgun: {
    hasTrackingUI: true,
    espTxtValue: 'v=spf1 include:mailgun.org ~all',
  },
};

export const CSV_CONTACT_LIMIT = 1000;
export const getContactLimitError = current => (
  `Max limit of possible contacts is 1k, your current CSV contains ${current}.`
);
export const READER_ERROR = 'An error ocurred while processing the CSV';
export const SELECT_ALL_SUCCESS = 'Action has been applied, please refresh in a minute or two';

export const ADMIN_GROUP = 'Admin';

export const MESSAGE_BODY_LIMIT = 5000;

export const SUPPORT_EMAIL = 'support@prvolt.com';
